import React from "react";
import "../../Styles/ReportsPage.css";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const AdminReportsPage = () => {
  const summaryCards = [
    {
      label: "Total Beneficiaries",
      value: "4,268",
      change: "+186 this month",
      type: "rep123-card-blue",
      icon: "users",
    },
    {
      label: "Total Amount Disbursed",
      value: "₹2.4 Cr",
      change: "+₹18L this month",
      type: "rep123-card-green",
      icon: "rupee",
    },
    {
      label: "Events Conducted",
      value: "132",
      change: "+9 this month",
      type: "rep123-card-purple",
      icon: "calendar",
    },
    {
      label: "Pending Requests",
      value: "217",
      change: "-32 this month",
      type: "rep123-card-orange",
      icon: "clipboard",
      negative: true,
    },
  ];

  const schemeData = [
    { scheme: "CM Relief Fund", icon: "🩺", total: 486, approved: 402, pending: 84, amount: "₹58,20,000", percent: 83 },
    { scheme: "Aadabidda Nidhi", icon: "🎓", total: 1240, approved: 1180, pending: 60, amount: "₹17,70,000", percent: 95 },
    { scheme: "Thalliki Vandanam", icon: "👩", total: 890, approved: 810, pending: 80, amount: "₹1,21,50,000", percent: 91 },
    { scheme: "Deepam Scheme", icon: "🔥", total: 654, approved: 590, pending: 64, amount: "—", percent: 90 },
    { scheme: "Maha Shakthi", icon: "⚡", total: 512, approved: 512, pending: 0, amount: "—", percent: 100 },
    { scheme: "Annadata Sukhibhava", icon: "🌾", total: 348, approved: 300, pending: 48, amount: "₹60,00,000", percent: 86 },
    { scheme: "Yuvagalam", icon: "🧑", total: 138, approved: 96, pending: 42, amount: "₹4,50,000", percent: 70 },
  ];

  // ---------- APPLICATIONS OVERVIEW (Donut) ----------
  const totalApplications = 4268;
  const applicationsBreakdown = [
    { name: "Approved", value: 3890, percent: "91%", color: "#16a34a" },
    { name: "Pending", value: 278, percent: "6.5%", color: "#f59e0b" },
    { name: "Rejected", value: 100, percent: "2.5%", color: "#dc2626" },
  ];

  // ---------- TREND OVERVIEW (Line chart, last 6 months) ----------
  const trendData = [
    { month: "Feb", applications: 620, approvals: 480 },
    { month: "Mar", applications: 780, approvals: 650 },
    { month: "Apr", applications: 900, approvals: 790 },
    { month: "May", applications: 980, approvals: 900 },
    { month: "Jun", applications: 1080, approvals: 1010 },
    { month: "Jul", applications: 1129, approvals: 1150 },
  ];

  const totalApplicationsTrend = 5489;
  const totalApprovalsTrend = 4980;

  return (
    <div className="rep123-page">
      {/* Header */}
      <div className="rep123-header">
        <div>
          <h2 className="rep123-title">Reports &amp; Analytics</h2>
          <p className="rep123-subtitle">
            Overview of schemes, beneficiaries and activities.
          </p>
        </div>

        <div className="rep123-filter-section">
          <select className="rep123-select">
            <option>All Mandals</option>
            <option>Kandukur</option>
            <option>Gudluru</option>
            <option>Ulavapadu</option>
          </select>

          <select className="rep123-select">
            <option>This Month</option>
            <option>Last 3 Months</option>
            <option>Last 6 Months</option>
            <option>This Year</option>
          </select>

          <button className="rep123-export-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 3v12m0 0l-4-4m4 4l4-4"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
            Export Report
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="rep123-cards-grid">
        {summaryCards.map((card, index) => (
          <div key={index} className={`rep123-card ${card.type}`}>
            <div className="rep123-card-top">
              <p className="rep123-card-label">{card.label}</p>
              <div className={`rep123-card-icon rep123-icon-${card.icon}`}>
                {card.icon === "users" && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.7" />
                    <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                    <circle cx="17" cy="8" r="2.6" stroke="currentColor" strokeWidth="1.7" />
                    <path d="M15.5 14.7c2.6.4 4.5 2.3 4.5 5.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                  </svg>
                )}
                {card.icon === "rupee" && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M6 4h12M6 9h12M6 4c4 0 6 1.8 6 4.5S10 13 6 13l8 8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
                {card.icon === "calendar" && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7" />
                    <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                  </svg>
                )}
                {card.icon === "clipboard" && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect x="5" y="4" width="14" height="17" rx="2" stroke="currentColor" strokeWidth="1.7" />
                    <path d="M9 4V3a1 1 0 011-1h4a1 1 0 011 1v1M9 11h6M9 15h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                  </svg>
                )}
              </div>
            </div>

            <h3 className="rep123-card-value">{card.value}</h3>

            <span
              className={`rep123-card-change ${
                card.negative ? "rep123-change-negative" : "rep123-change-positive"
              }`}
            >
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                {card.negative ? (
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                ) : (
                  <path d="M6 15l6-6 6 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                )}
              </svg>
              {card.change}
            </span>
          </div>
        ))}
      </div>

      {/* Overview Row: Donut + Trend */}
      <div className="rep123-overview-row">
        {/* Applications Overview Donut */}
        <div className="rep123-overview-card rep123-donut-card">
          <h3 className="rep123-section-title">Applications Overview</h3>

          <div className="rep123-donut-wrap">
            <div className="rep123-donut-chart">
              <ResponsiveContainer width="100%" height={180}>
                <PieChart>
                  <Pie
                    data={applicationsBreakdown}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={55}
                    outerRadius={78}
                    paddingAngle={2}
                    startAngle={90}
                    endAngle={-270}
                  >
                    {applicationsBreakdown.map((entry, i) => (
                      <Cell key={i} fill={entry.color} stroke="none" />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>

              <div className="rep123-donut-center">
                <span className="rep123-donut-total">
                  {totalApplications.toLocaleString()}
                </span>
                <span className="rep123-donut-total-label">Total</span>
              </div>
            </div>

            <div className="rep123-donut-legend">
              {applicationsBreakdown.map((item, i) => (
                <div className="rep123-legend-row" key={i}>
                  <span
                    className="rep123-legend-dot"
                    style={{ background: item.color }}
                  />
                  <span className="rep123-legend-label">{item.name}</span>
                  <span className="rep123-legend-value">
                    {item.value.toLocaleString()} ({item.percent})
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trend Overview */}
        <div className="rep123-overview-card rep123-trend-card">
          <div className="rep123-trend-header">
            <h3 className="rep123-section-title">Trend Overview (Last 6 Months)</h3>

            <div className="rep123-trend-legend">
              <span className="rep123-trend-legend-item">
                <span className="rep123-trend-dot rep123-dot-blue" /> Applications
              </span>
              <span className="rep123-trend-legend-item">
                <span className="rep123-trend-dot rep123-dot-green" /> Approvals
              </span>
            </div>
          </div>

          <div className="rep123-trend-body">
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={trendData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                <CartesianGrid vertical={false} stroke="#f0f1f3" />
                <XAxis
                  dataKey="month"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 12, fill: "#9ca3af" }}
                />
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 12, fill: "#9ca3af" }}
                  tickFormatter={(v) => (v >= 1000 ? `${v / 1000}K` : v)}
                />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="applications"
                  stroke="#2563eb"
                  strokeWidth={2.5}
                  dot={{ r: 4, fill: "#2563eb" }}
                />
                <Line
                  type="monotone"
                  dataKey="approvals"
                  stroke="#16a34a"
                  strokeWidth={2.5}
                  dot={{ r: 4, fill: "#16a34a" }}
                />
              </LineChart>
            </ResponsiveContainer>

            <div className="rep123-trend-stats">
              <div className="rep123-trend-stat rep123-trend-stat-blue">
                <span className="rep123-trend-stat-label">Total Applications</span>
                <span className="rep123-trend-stat-value">
                  {totalApplicationsTrend.toLocaleString()}
                </span>
              </div>
              <div className="rep123-trend-stat rep123-trend-stat-green">
                <span className="rep123-trend-stat-label">Total Approvals</span>
                <span className="rep123-trend-stat-value">
                  {totalApprovalsTrend.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scheme-wise Breakdown */}
      <div className="rep123-table-card">
        <h3 className="rep123-section-title">Scheme-wise Beneficiary Summary</h3>

        <div className="rep123-table-wrapper">
          <table className="rep123-table">
            <thead>
              <tr>
                <th>Scheme</th>
                <th>Total Applications</th>
                <th>Approved</th>
                <th>Pending</th>
                <th>Amount Disbursed</th>
                <th>Approval Rate</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {schemeData.map((row, index) => (
                <tr key={index}>
                  <td>
                    <div className="rep123-scheme-cell">
                      <span className="rep123-scheme-icon">{row.icon}</span>
                      <span className="rep123-scheme-name">{row.scheme}</span>
                    </div>
                  </td>
                  <td>{row.total.toLocaleString()}</td>
                  <td className="rep123-approved-text">
                    {row.approved.toLocaleString()}
                  </td>
                  <td className="rep123-pending-text">{row.pending}</td>
                  <td>{row.amount}</td>
                  <td>
                    <div className="rep123-progress-cell">
                      <div className="rep123-progress-bar">
                        <div
                          className="rep123-progress-fill"
                          style={{ width: `${row.percent}%` }}
                        ></div>
                      </div>
                      <span className="rep123-progress-percent">{row.percent}%</span>
                    </div>
                  </td>
                  <td>
                    <button className="rep123-row-arrow">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="rep123-table-footer">
          <span className="rep123-table-footer-info">
            Showing 1 to {schemeData.length} of {schemeData.length} schemes
          </span>

          <div className="rep123-table-pagination">
            <button className="rep123-page-arrow">&lt;</button>
            <button className="rep123-page-num rep123-active">1</button>
            <button className="rep123-page-arrow">&gt;</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminReportsPage;